// This simple wrapper is provided solely as a convenience so that
// callers can cleanly invoke the Google TagManager API
// (https://developers.google.com/tag-platform/tag-manager/web/datalayer)
// without regard to whether window.dataLayer exists.


export default {
  gtag() {
    // biome-ignore lint/correctness/noUndeclaredVariables: Google gtag contract requires `arguments`, not rest params
    window.dataLayer?.push(arguments)
  },

  push(payload) {
    window.dataLayer?.push(payload)
  },
}
